<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>Return By Customer For Repair</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="accent" small to="/new-repair">
            <v-icon left dark>mdi-plus</v-icon>New Repair
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="repairs"
              :search="search"
              :mobile-breakpoint="zeroValue"
            >
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="accent" text @click="dealerModal(item)">Assign Dealer</v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <v-row>
          <!-- dealer dialog -->
          <v-dialog v-model="assignDialog" max-width="750px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Dealer Assignment</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="assignDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid class="subtitle-2 text--primary">
                  <v-row class="subtitle-2 text--primary">
                    <v-col cols="12" xs="12" md="6">
                      Job No: {{activeItem.JobNo}}
                      <br />
                      Customer: {{activeItem.CustomerName}}
                      <br />
                      Phone No: {{activeItem.CustomerPhone}}
                    </v-col>

                    <v-col cols="12" xs="12" md="6">
                      <div v-if="activeItem.product">
                        Item:
                        <span style="color: red">{{activeItem.product.Name}}</span>
                      </div>Problem Details:
                      <span style="color: red">{{activeItem.ProblemDetails}}</span>
                    </v-col>

                    <v-col cols="12" xs="12" md="6">
                      <v-autocomplete
                        autocomplete="off"
                        dense
                        outlined
                        v-model="Dealer"
                        :items="dealers"
                        label="Select Dealer"
                        item-text="Name"
                        item-value="id"
                      >
                        <template v-if="enableCreate" v-slot:no-data>
                          <v-row align="center" justify="center">
                            <v-btn
                              :loading="searchingProduct"
                              class="ma-2"
                              color="accent"
                              dark
                              small
                              elevation="0"
                              @click="quickModal()"
                            >
                              <v-icon left>mdi-plus</v-icon>Create A Dealer
                            </v-btn>
                          </v-row>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="6">
                      <v-btn color="accent" @click="assignDealer" :loading="loader">
                        <v-icon left>mdi-content-save</v-icon>Deliver To Dealer
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of dealer modal-->

          <!-- dealer quick add dialog -->
          <v-dialog v-model="quickDialog" max-width="750px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Create A Dealer</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="quickDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <dealer-editor :docCreate="true" :initial="dealerItem" @data="saveDealer"></dealer-editor>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of modal-->

          <snackbar ref="snackbar"></snackbar>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import DealerEditor from "@/components/subscriber/repairs/dealers/_components/quick-editor.vue";
export default {
  components: {
    DealerEditor,
  },
  data: () => ({
    search: "",
    activeItem: {},
    enableCreate: true,
    searchingProduct: false,
    quickDialog: false,
    dealerItem: {},
    Dealer: null,
    assignDialog: false,
    zeroValue: 0,
    loader: false,
    pageItems: 100,
    headers: [
      { text: "Job No.", value: "JobNo" },
      { text: "Customer", value: "CustomerName" },
      { text: "Phone No.", value: "CustomerPhone" },
      { text: "Email", value: "CustomerEmail" },
      { text: "Item", value: "product.Name" },
      { text: "Problem Details", value: "ProblemDetails" },
      { text: "Received By", value: "received_by.name" },
      { text: "Date Returned", value: "ReturnDate" },
      { text: "Action", value: "action" },
    ],
    dealers: [],
    repairs: [],
  }),
  methods: {
    dealerModal(data) {
      this.activeItem = data;
      this.assignDialog = true;
    },
    quickModal() {
      this.quickDialog = true;
    },
    saveDealer(data) {
      const url = "/dealers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            const dealer = res.ResponseData;
            self.dealers = [...this.dealers, dealer];
            self.Dealer = dealer.id;
            self.$refs.snackbar.show("Dealer Added Successully", "green");
            self.quickDialog = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    assignDealer() {
      if (this.Dealer == null || this.Dealer == undefined) {
        this.$refs.snackbar.show("Please select dealer", "red");
      } else {
        const data = {
          id: this.activeItem.id,
          Dealer: this.Dealer,
        };
        const url = `/repair/assign/dealer`;
        const self = this;
        this.loader = true;
        this.$store
          .dispatch("post", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.$refs.snackbar.show("Assigned successfully", "green");
              self.loader = false;
              self.assignDialog = false;
              self.getRepairs();
            } else {
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    getRepairs() {
      const self = this;
      this.$store
        .dispatch("get", `/repairs/0`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.repairs = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDealers() {
      const self = this;
      this.$store
        .dispatch("get", `/dealers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.dealers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getRepairs();
    this.getDealers();
  },
};
</script>